/**
 * On-site currency converter (display-only).
 * Converts visible AED prices to USD / EUR / GBP / SAR / KWD / QAR.
 * Checkout remains in the shop currency (AED) until Shopify Markets
 * presentment currencies are enabled.
 */
(function () {
  var STORAGE_KEY = 'alboushiya_display_currency';
  var BASE = 'AED';
  var RATE_URL = 'https://open.er-api.com/v6/latest/AED';
  var FALLBACK_RATES = {
    AED: 1,
    USD: 0.2723,
    EUR: 0.251,
    GBP: 0.214,
    SAR: 1.021,
    KWD: 0.0835,
    QAR: 0.991,
  };

  var rates = null;
  var current = localStorage.getItem(STORAGE_KEY) || BASE;

  function formatAmount(value, code) {
    var digits = code === 'KWD' ? 3 : 2;
    return (
      code +
      ' ' +
      Number(value).toLocaleString('en-US', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      })
    );
  }

  function parseMoneyText(text) {
    var m = String(text || '').match(
      /\b(AED|USD|EUR|GBP|SAR|KWD|QAR)\s*([0-9]{1,3}(?:,[0-9]{3})*(?:\.[0-9]+)?|[0-9]+(?:\.[0-9]+)?)/
    );
    if (!m) return null;
    return { code: m[1], amount: parseFloat(m[2].replace(/,/g, '')), raw: m[0] };
  }

  function convert(amountAed, toCode) {
    if (!rates || !rates[toCode]) return amountAed;
    return amountAed * rates[toCode];
  }

  function toAed(amount, fromCode) {
    if (!rates || !rates[fromCode] || rates[fromCode] === 0) return amount;
    return amount / rates[fromCode];
  }

  function rewriteTextNode(node) {
    if (!node || node.nodeType !== 3) return;
    var value = node.nodeValue;
    if (!value || !/\b(AED|USD|EUR|GBP|SAR|KWD|QAR)\b/.test(value)) return;

    var parent = node.parentElement;
    if (parent && (parent.closest('script') || parent.closest('style') || parent.closest('noscript'))) {
      return;
    }

    var updated = value.replace(
      /\b(AED|USD|EUR|GBP|SAR|KWD|QAR)\s*([0-9]{1,3}(?:,[0-9]{3})*(?:\.[0-9]+)?|[0-9]+(?:\.[0-9]+)?)/g,
      function (match, code, num) {
        var amount = parseFloat(String(num).replace(/,/g, ''));
        if (isNaN(amount)) return match;
        var aed = code === BASE ? amount : toAed(amount, code);
        return formatAmount(convert(aed, current), current);
      }
    );

    if (updated !== value) node.nodeValue = updated;
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      rewriteTextNode(root);
      return;
    }
    if (root.nodeType !== 1) return;
    if (root.matches && root.matches('script, style, noscript, .currency-selector')) return;

    var nodes = root.querySelectorAll
      ? null
      : null;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    while (walker.nextNode()) rewriteTextNode(walker.currentNode);
  }

  function applyAll() {
    if (!rates) return;
    walk(document.body);
    document.documentElement.setAttribute('data-display-currency', current);
  }

  function syncSelects() {
    document.querySelectorAll('[data-currency-converter-select]').forEach(function (select) {
      select.value = current;
    });
  }

  function setCurrency(code) {
    if (!code || !FALLBACK_RATES[code]) return;
    current = code;
    localStorage.setItem(STORAGE_KEY, code);
    syncSelects();
    applyAll();
  }

  function bindSelects() {
    document.querySelectorAll('[data-currency-converter-select]').forEach(function (select) {
      if (select.dataset.bound === '1') return;
      select.dataset.bound = '1';
      select.addEventListener('change', function () {
        setCurrency(select.value);
      });
    });
  }

  function loadRates() {
    rates = Object.assign({}, FALLBACK_RATES);
    return fetch(RATE_URL, { credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('rate fetch failed');
        return r.json();
      })
      .then(function (data) {
        if (data && data.rates) {
          Object.keys(FALLBACK_RATES).forEach(function (code) {
            if (data.rates[code]) rates[code] = data.rates[code];
          });
          rates.AED = 1;
        }
      })
      .catch(function () {
        /* keep fallback rates */
      });
  }

  // Expose for cart / wishlist redraws
  window.AlboushiyaCurrency = {
    getCode: function () {
      return current;
    },
    formatFromAedCents: function (cents) {
      var aed = Number(cents || 0) / 100;
      return formatAmount(convert(aed, current), current);
    },
    apply: applyAll,
    set: setCurrency,
  };

  // Hook existing money formatters if present later
  var originalFix = window.fixCurrency;
  window.fixCurrency = function () {
    if (typeof originalFix === 'function') originalFix();
    applyAll();
  };

  function boot() {
    bindSelects();
    syncSelects();
    loadRates().then(function () {
      applyAll();
      if ('MutationObserver' in window) {
        var pending = false;
        new MutationObserver(function () {
          if (pending) return;
          pending = true;
          requestAnimationFrame(function () {
            pending = false;
            bindSelects();
            applyAll();
          });
        }).observe(document.body, { childList: true, subtree: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
